import { apiCall, ApiConfig } from '../../config/api'
import { TypeSetting } from '../../interfaces/Settings/settings'
import { getTypeSettingAction } from '../actions/typeSettingActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosResponse } from 'axios'
import { GET_TYPE_SETTING } from '../types/typeSettingActionsTypes'

export function* getTypesSettingAsync() {
  try {
    const { status, data }: AxiosResponse<TypeSetting[]> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.SettiingsApi}/typeSettings`
    )
    if (status === 200) {
      yield put(getTypeSettingAction(data))
    }
  } catch (error) {
    const serverError = error as { data?: { message?: string } }
    const errorMessage =
      serverError?.data?.message ?? 'Error al cargar los tipos de configuración'
    yield put(getTypeSettingAction([], errorMessage))
  }
}

export function* watchGetTypesSettingAsync() {
  yield takeEvery(GET_TYPE_SETTING, getTypesSettingAsync)
}
